module.exports = {
        srcSet: __webpack_public_path__ + "static/media/section3-498.c57a6a99.webp"+" 498w",
        images: [{path: __webpack_public_path__ + "static/media/section3-498.c57a6a99.webp",width: 498,height: 498}],
        src: __webpack_public_path__ + "static/media/section3-498.c57a6a99.webp",
        toString: function(){return __webpack_public_path__ + "static/media/section3-498.c57a6a99.webp"},
        
        width: 498,
        height: 498
      }